module.exports = __webpack_public_path__ + "static/logo-white-android-c7bf1d1e948165e2756317450e813357.svg";